import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, Loader2, MessageSquareText } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export function SectionNote({ companyId, section, label, value, onSaved }) {
  const [text, setText] = useState(value || "");
  const [saving, setSaving] = useState(false);
  const [dirty, setDirty] = useState(false);

  useEffect(() => { setText(value || ""); setDirty(false); }, [value, companyId, section]);

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/companies/${companyId}/notes`, { [section]: text });
      toast.success("Commento salvato: comparirà nel report PDF");
      setDirty(false);
      onSaved?.(section, text);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card className="p-5 mt-6" data-testid={`section-note-${section}`}>
      <div className="flex items-center gap-2 mb-3">
        <MessageSquareText className="h-4 w-4 text-primary" />
        <h4 className="font-heading font-semibold text-sm">{label}</h4>
        <span className="text-[10px] uppercase tracking-wider text-muted-foreground ml-auto">Incluso nel PDF</span>
      </div>
      <Textarea
        rows={3}
        value={text}
        onChange={(e) => { setText(e.target.value); setDirty(true); }}
        placeholder="Scrivi qui il commento per questa sezione..."
        data-testid={`section-note-input-${section}`}
      />
      <div className="flex justify-end mt-3">
        <Button size="sm" onClick={save} disabled={saving || !dirty} data-testid={`section-note-save-${section}`}>
          {saving ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <Save className="h-4 w-4 mr-1.5" />} Salva Commento
        </Button>
      </div>
    </Card>
  );
}
